



import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class HeaderLogo extends Vue {
  private onClickImgHeader():void {
    this.$router.push({name: 'routes.home'})
  }
}
